<template>
  <div v-if="visible" class="model-wrapper">
    <div class="p-6 w-108 max-w-9/10 absolute top-1/2 left-1/2 bg-white rounded-md model">
      <div class="title flex items-center mb-6">
        <img src="../assets/warning.svg" alt="删除" class="mr-2" />
        <div class="font-medium text-lg">删除笔记</div>
      </div>
      <div class="content mb-6">确定删除该笔记吗？笔记删除之后将无法恢复！</div>
      <div class="action-wrapper">
        <!-- PC -->
        <div class="hidden md:flex justify-end mb-2">
          <button class="mr-4 py-1 px-2 tracking-widest rounded pc-cancel-button" @click="close">
            取 消
          </button>
          <button
            class="py-1 px-2 tracking-widest rounded text-white border confirm-button"
            @click="handelDelete"
          >
            确 认
          </button>
        </div>
        <!-- mb -->
        <div class="md:hidden mb-2 flex justify-between">
          <button
            class="flex-1 mr-4 py-1 px-2 tracking-widest rounded pc-cancel-button"
            @click="close"
          >
            取 消
          </button>
          <button
            class="flex-1 py-1 px-2 tracking-widest rounded text-white border confirm-button"
            @click="handelDelete"
          >
            确 认
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';
@Component
export default class Delete extends Vue {
  visible = false;
  noteId = '';
  open(id: string) {
    this.visible = true;
    this.noteId = id;
  }

  close() {
    this.visible = false;
  }

  handelDelete() {
    this.$emit('delete', this.noteId);
    this.close();
  }
}
</script>
<style scoped>
.model-wrapper {
  @apply fixed top-0 left-0 right-0 bottom-0;
  background-color: rgba(0, 0, 0, 0.65);
}
.model {
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
  transform: translate(-50%, -50%);
}

.mb-action-wrapper {
  @apply border border-motif-500;
}

.pc-cancel-button {
  color: rgba(0, 0, 0, 0.65);
  border: 1px solid rgba(0, 0, 0, 0.15);
}

.cancel-button {
  @apply text-motif-400;
}

.confirm-button {
  @apply bg-motif;
}
</style>
